import WRAP from "WRAP-JS";
import image from "../../../images/contents/map/powerPylon/powerPylon.svg";

/* eslint-disable */
WRAP.Renderer.PowerPylon = function() {
  WRAP.Renderer.GeoJSONExt.call(this);

  const features = [];
  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  const superDraw = this.draw;
  let buffer;
  let mask;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {
    buffer = {};
    superDraw.apply(this, arguments);
    if (this.drawFlg) {
      features.splice(0);
      features.push.apply(features, Object.values(buffer));
    }
    mask = new WRAP.Geo.Mask(WRAP.Geo.currentView());
    mask.clear();
    layer.clear();
    features.forEach(val => {
      this._drawFeatureImpl(layer, val[0], val[1], val[2]);
    });
    WRAP.Geo.invalidate();
  }

  this.drawFeature = function(layer, item, prop, ts) {
    if (prop.preferred_route_type) {
      return;
    }
    buffer[prop.gid] = buffer[prop.gid] || [
      item,
      prop,
      ts
    ];
  }

  this._drawFeatureImpl = function(layer, item, prop, ts) {

    const style = {...{
      image: image,
      width: 32,
      height: 32,
      offsetX: -16,
      offsetY: -16
    }, ...ts};

    prop.fixes.forEach(fix => {
      if (!mask.intersectRect(fix, style.offsetX, style.offsetY, style.width, style.height)) {
        mask.addRect(fix, style.offsetX, style.offsetY, style.width, style.height);
        const featureImage = new WRAP.Geo.Feature.Image({...{point: fix}, ...style});
        addFeature(layer, featureImage, item, undefined);
      }
    });
  }

};
/* eslint-enable */